import { render, staticRenderFns } from "./AlbumNav.vue?vue&type=template&id=0c4e5584&scoped=true&"
import script from "./AlbumNav.vue?vue&type=script&lang=js&"
export * from "./AlbumNav.vue?vue&type=script&lang=js&"
import style0 from "./AlbumNav.vue?vue&type=style&index=0&id=0c4e5584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e5584",
  null
  
)

export default component.exports